import { render, staticRenderFns } from "./ProgramTabCommunication.vue?vue&type=template&id=72dbaa7c&"
import script from "./ProgramTabCommunication.vue?vue&type=script&lang=js&"
export * from "./ProgramTabCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports